module.exports = __webpack_public_path__ + "media/images/stock_photography/sand_traps-525dd71995361d489f3fb917cf2f6fc1.jpg";